




















import Vue from 'vue';
import { AmendmentViewModel } from "../../models/AmendmentViewModel";

export default Vue.extend( {
  name: "AmendmentListPanel",
  components: {},
  data(): {
    amendmentList: AmendmentViewModel[];
    amendmentHeaders: any[];
    isLoading: boolean;
  }{
    return {
      amendmentList: [],
      amendmentHeaders: [
        { text: 'Identifier' , value: 'compositeIdentifier', align: 'start' },
        { text: 'Municipality' , value: 'municipalityName' },
        { text: 'Work Area' , value: 'workAreaDisplay' } ,
        { text: 'Submitted By' , value: 'submittedName' } ,
        { text: 'Date Submitted' , value: 'whenSubmittedDisplay' },
        { text: 'Status' , value: 'statusText' }
      ],
      isLoading: true
    }
  },
  methods: {
    async loadData() {
      let result = await this.axios.get("/Amendments/GetList");
      this.amendmentList = result.data;
      this.isLoading = false;
    }
  },
  mounted: async function() {
    await this.loadData();
  }
} )

